import {PrincipalUtil} from "../../utils/PrincipalUtil";

export class LoggedInUserResolver {
    static instance = [
        function () {
            return PrincipalUtil.getPrinciple();
        }
    ]
}